module.exports = __webpack_public_path__ + "media/15.97f99c0c.wav";